import React, { Component } from "react";
import PriceListItem from "./PriceListItem";

const defaultState = [
  {
    title: "Starter",
    display: 2,
    price: "IDR 150.000",
    unit: "PER MONTH",
    content: <ul>
      <li>1 User</li>
      <li>1 GB Storage</li>
      <li>Support Center</li>
      <li>Basic Report</li>
    </ul>
  },
  {
    title: "Professional",
    display: 6,
    price: "IDR 400.000",
    unit: "PER MONTH",
    content: <ul>
      <li>2 Users</li>
      <li>10 GB Storage</li>
      <li>Support Center</li>
      <li>Email Support</li>
      <li>Basic Report</li>
    </ul>
  },
  {
    title: "Agency",
    display: 15,
    price: "IDR 850.000",
    unit: "PER MONTH",
    content: <ul>
      <li>3 Users</li>
      <li>25 GB Storage</li>
      <li>Support Center</li>
      <li>Email Support</li>
      <li>Basic Report</li>
    </ul>
  },
  {
    isRecommended: true,
    title: "Enterprises",
    display: "15+",
    price: "Contact Us",
    unit: "\u00a0",
    content: <ul>
      <li>Unlimited Users</li>
      <li>Unlimited Storage</li>
      <li>Email & Telephone Priority Support</li>
      <li>Custom Apps Support</li>
      <li>Network Monitoring</li>
    </ul>
  }
];

export default class PricingList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      list: defaultState,
    };
  }

  render() {
    const listItem = this.state.list.map((item, id) => <div key={id} className="col-sm-6 col-xs-12 col-md-3">
      <PriceListItem {...item}>{item.content}</PriceListItem></div>)
    return (
      <section>
        <div className="row row-eq-height price-list">
          {listItem}
        </div>
      </section>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Page/Pricing/PriceList.js